import { combineReducers } from '@reduxjs/toolkit'

import sideMenu from './sideMenu/reducer'
import artists from './artists/reducer'
import trackListRemote from './trackListRemote/reducer'
import musicalGenres from './musicalGenres/reducer'
import licenses from './licenses/reducer'
import moods from './moods/reducer'
import socialMedia from './socialMedia/reducer'
import users from './users/reducer'
import admin from './admin/reducer'
import albums from './albums/reducer'
import campaigns from './campaigns/reducer'
import scenes from './scenes/reducer'

export default combineReducers({
  sideMenu,
  artists,
  trackListRemote,
  musicalGenres,
  licenses,
  moods,
  socialMedia,
  users,
  admin,
  albums,
  campaigns,
  scenes,
})
